export enum ProcessingState {
    Processing = "processing",
    Processed = "processed",
    Failed = "failed"
}

export interface TerminationVM {
    EmployeeID: number;
    isSelected: boolean;
    processingState: ProcessingState;
}

export interface NewHireVM {
    isSelected: boolean;
    processingState: ProcessingState;
    EmployeeID: number;
    ADPEmployeeID: number;
    SSN: string;
    FEIN: string;
}
